import Vue from 'vue';
import {
  IHistoryStore,
  IActionsSignature,
  IHistoryShipment,
  initialHistoryShipment,
} from "@/models/StoreModels";
import * as services from "@/services/services";
import {find} from "ramda";
import {load} from "google-maps";

const FIRST_PAGE = 1;


const initialState = (): IHistoryStore => {
  return {
    currentShipment: initialHistoryShipment(),
    shipments: [],
    page: FIRST_PAGE,
    lastEmpty: false,
  };
};


const getters = {
  /**
   * return an ordered shipmentLIst list
   */
  getShipments(state: IHistoryStore): IHistoryShipment[] {
    return state.shipments;

    // the ones that need to be picked up must be shown first
    // the one the user created must be first
  },
  /**
   * return an ordered shipmentLIst list
   */
  getCurrentShipment(state: IHistoryStore): IHistoryShipment {
    return state.currentShipment;

    // the ones that need to be picked up must be shown first
    // the one the user created must be first
  },

  existMorePages(state: IHistoryStore): boolean {
    return !state.lastEmpty;

    // the ones that need to be picked up must be shown first
    // the one the user created must be first
  },

};


const actions = {
  reset({commit, state}: IActionsSignature<IHistoryStore>) {
    commit('reset');
  },

  loadStory({commit, state}: IActionsSignature<IHistoryStore>): Promise<any> {
    if (!state.lastEmpty) {
      return services.apiCaller.GET(`/shipments/history?page=${state.page}&orderDirection=DESC`, [])
        .then((myShipments) => {
          commit('updateHistoryShipments', myShipments);
        });
    }
    return Promise.resolve();
  },


  loadShipment({commit, state}: IActionsSignature<IHistoryStore>, id: number): Promise<any> {
    if (id === 0) {
      commit('updateCurrentShipment', initialHistoryShipment());
      return Promise.resolve();
    }

    const myShipment: IHistoryShipment | undefined = find((el: IHistoryShipment) => el.id === id, state.shipments);

    if (myShipment) {
      commit('updateCurrentShipment', myShipment);
      return Promise.resolve();
    }

    return services.apiCaller.GET(`/shipments/${id}`, initialHistoryShipment())
                    .then((loadedShipment: IHistoryShipment): boolean  => {
                      commit('updateCurrentShipment', loadedShipment);
                      return loadedShipment.id === 0;
                    })
                    .then((mustReject): Promise<any> => mustReject ? Promise.reject() : Promise.resolve());
  },
};


const mutations = {
  reset(state: IHistoryStore) {
    Vue.set(state, "currentShipment", initialHistoryShipment());
    Vue.set(state, "shipments", []);
    Vue.set(state, "page", FIRST_PAGE);
    Vue.set(state, "lastEmpty", false);
  },

  updateHistoryShipments(state: IHistoryStore, shipments: IHistoryShipment[]) {
    if (shipments.length === 0) {
      Vue.set(state, "lastEmpty", true);
    } else {
      Vue.set(state, "shipments", [...state.shipments, ...shipments]);
      Vue.set(state, "page", state.page + 1);
    }
  },

  updateCurrentShipment(state: IHistoryStore, shipment: IHistoryShipment) {
    Vue.set(state, "currentShipment", shipment);
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
